import _ from 'lodash';
import marked from 'marked';

export default function install(Vue) {
  Vue.mixin({
    methods: {
      /**
       * Frequently used lodash helper to determine if an object is empty.
       *
       * @param object
       * @returns {boolean}
       */
      empty(object) {
        return _.isEmpty(object);
      },

      /**
       * Sorts the given array by the given key, ignoring its caseing
       *
       * @param array
       * @param key
       * @returns {Array|*}
       */
      ignoreCaseOrderBy(array, key) {
        return _.orderBy(array, entry => _.get(entry, key).toLowerCase());
      },

      /**
       * Slices up the given array into a number of chunks.
       *
       * @param array
       * @param slices
       * @returns {*|Array}
       */
      chunk(array, slices) {
        return _.chunk(array, slices);
      },

      /**
       * Converts the given text/string from markdown to HTML.
       *
       * @param text
       * @returns {*}
       */
      md(text) {
        return marked(text);
      },

      /**
       * Sets the value of an item in an array to the one in the given input field.
       *
       * This is being used when updating and watching arrays, as Vue cannot listen
       * for those changes by itself.
       *
       * @param object The array we're tracking
       * @param index The index of the object in our array
       * @param attribute The name of the changing attribute
       * @param event Either the $event or the new value
       * @param method An optional method that can be called to track the changes
       *               "function (object, attribute, value, old)"
       */
      set(array, index, attribute, event, method = null) {
        const old = array[index][attribute];
        const value = _.isObject(event) ? event.target.value : event;

        this.$set(array[index], attribute, value);

        if (method !== null) {
          method(array[index], attribute, value, old);
        }
      },

      indexFor(array, id, key = 'id') {
        return _.findIndex(array, [key, id]);
      },
    },
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/vue-extensions/utils.js